import { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import apiService from '../../services/apiService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { DateFormatter } from "../../utils/DateFormatter";
import { FilterMatchMode } from 'primereact/api';
import { InputText } from "primereact/inputtext";

// import '../../styles/pages/dataSets.scss';
// import DatasetsCard from "../../components/DatasetsCard";
// import DatasetsModal from "../../components/DatasetsModal";
import Add from "../../assets/icons/add"

export default function FileList() {
    // const [dataSetList, setdataSetList] = useState([]);
    // const [publicDataList, setPublicDataList] = useState([]);
    // const [privateDataList, setPrivateDataList] = useState([]);
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
    const [workflowData, setWorkflowData] = useState([]);
    const [files, setFiles] = useState([]);
    const navigate = useNavigate();
    const [extraNavItems, setExtraNavItems] = useOutletContext();

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getDataUserToken}`,
    };

    function getSessionStorageOrDefault(key, defaultValue) {
        const stored =  sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
    
      }

    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );

    useEffect(() => {
        document.title = 'Data -> Files | Palmona Pathogenomics'
    }, []);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/workflowDsInfo?userId=${userid}`, {
            headers,
        })
        .then((res) => res.json())
            .then(data => setWorkflowData(data))
            .catch((error) => {
                console.log('Error in getting workflowdata', error);
            });
    }, [])

    useEffect(() => {
        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/file?userId=${userid}`, {
            headers,
        })
            .then((res) => res.json())
            .then(data => setFiles(data))
            .catch((error) => {
                console.log('Error in getting file data', error);
            });
    }, [])

    const dateTemplate = (workflow) => {
        return DateFormatter(workflow.createdAt);
    }

    const detailsTemplate = (file => {
        return (
            <Link to={`filedetails/${file.id}`}>
                {file.name}
            </Link>
        )
    })

    const groupsTemplate = (groups => {
        return groups.filegroups.map(group => group.id).join(',');
    })

    const navigateToFile = (dataset_name, dataset_id) =>{ 
        // const path = "manage_sample/new_sample/upload-csv" ; 
        const path = "dataset_details" ; 
        navigate(path,{
            state:{
                id:dataset_id,
                name:dataset_name
            }
        })
    }

    // Filters
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        createdAt: { value: null, matchMode: FilterMatchMode.EQUALS },
        id: {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </span>
            </div>
        );
    };


    const header = renderHeader();

    return (
        // <div className="datasets-main">
            <div className="d-flex row justify-content-between">
                <h1>User Files</h1>
                <DataTable 
                    className="w-75" 
                    paginator 
                    rows={10} 
                    rowsPerPageOptions={[5, 10, 25, 50]} 
                    value={files} 
                    responsiveLayout="scroll" 
                    stripedRows
                    filters={filters} 
                    filterDisplay="row"
                    globalFilterFields={['name', 'createdAt', 'id']}
                    header={header}
                    pt={{
                        paginator: {
                            style: { minWidth: '100rem' },
                            pt: {
                                RPPDropdown: {
                                    className: 'w-10px'
                                }
                            }
                        }
                    }}
                >
                    <Column field="name" header="File Name" body={detailsTemplate} sortable filter filterPlaceholder="Search by name"></Column>
                    {/* <Column field="filegroups" header="Groups" body={groupsTemplate}></Column> */}
                    {/* <Column field="number_of_samples" header="No. of Samples"></Column> */}
                    <Column field="createdAt" header="Date Created" body={dateTemplate} sortable filter filterPlaceholder="Search by date"></Column>
                    {/* <Column field="id" header="Details" body={detailsTemplate}></Column> */}
                </DataTable>
            </div>
        // </div>
    );
}